/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export const loadMyClients = createAsyncThunk('api/my-clients', async (_, { dispatch }) => {
    const myClients = await api.myClients.get();
    const requests = myClients.data.map((client) => {
        return dispatch(loadProfilePicture(client.id.toString()));
    });
    const rez = await Promise.allSettled(requests);

    const avatars = rez.map((item) => {
        if (item.status === 'fulfilled') {
            return { userId: item.value.meta.arg, url: (item.value.payload as any).data.url };
        } else {
            return null;
        }
    });

    const withAvatarURL = myClients.data.map((client) => {
        const avatar = avatars.find((item) => item?.userId === client.id.toString());
        return { ...client, avatarURL: avatar?.url };
    });

    return withAvatarURL;
});

export const loadProfilePicture = createAsyncThunk(
    'api/profile-picture',
    async (profile_id: string) => await api.resource.get('profile_picture', profile_id)
);
